module.exports = __webpack_public_path__ + "static/media/page92_01.15528032.jpg";